// Deploys always set it; only local dev leaves it out, and that runs against staging, never prod.
const MERMAIDD_SITE_URL = import.meta.env.VITE_MERMAIDD_SITE_URL || 'https://stg.mermaidd.com';

/** Case-list page on the mermaidd deploy — linked from the sidebar Mermaidd row. */
export const MERMAIDD_URL = `${MERMAIDD_SITE_URL}/case-list/`;
